<label class="switch">
    <input type="checkbox" [(ngModel)]="status" (click)="toggleStatus($event.currentTarget.checked,Timer)">
    <span class="slider round"></span>
</label>



<ng-template #Timer let-modal>
    <div class="modal-body">
        <div class="add_cattt d-flex justify-content-between">
            <h2>Available For</h2>
            <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
        </div>
        <div class="referral-link">
            <section class="m-4">
                <div class="form-group text-center">
                    <div class="border m-2"><input type="radio" name="hours"
                            aria-label="Radio button for following text input" (click)="selectedTime(4)"> 4 Hours</div>
                    <div class="border m-2"><input type="radio" name="hours"
                            aria-label="Radio button for following text input" (click)="selectedTime(8)"> 8 Hours</div>
                    <div class="border m-2"><input type="radio" name="hours"
                            aria-label="Radio button for following text input" (click)="selectedTime(12)"> 12 Hours
                    </div>
                </div>
            </section>
            <div class="mt-4">
                <div class="cart_btn">
                    <button class="com_btn add-review-btn px-2" (click)="saveTimer()">
                        Save <i class="fa fa-hourglass-end" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>